import React, { useState, useRef } from 'react';
import Backend from 'shared/lib/Backend';
import { useDebouncedEffect  } from 'shared/lib/debounce';

import { useCopywriter, useCopywriterDispatch } from './CopywriterContext';


const Prompt = ({ children }) => {

  const { prompt, content, fetching } = useCopywriter();
  const dispatch = useCopywriterDispatch();
  const handleChange = (e) => dispatch({ type: 'update_prompt', prompt: e.target.value });

  const [isLoading, setIsLoading] = useState(false);
  const abortRef = useRef(() => {});


  useDebouncedEffect(() => {

    if(fetching === false) return;

    setIsLoading(true);
    
    dispatch({ type: 'error', error: null });

    const body = JSON.stringify({ prompt, content });
    const [promise, abort] = Backend.abortablePostJson.call(null, `/frontend/assistant/copywriter`, { body });

    abortRef.current = () => { abort && abort() };

    promise
      .then((data) => {
        // console.log(data);

        if (data.response) {
          dispatch({ type: 'update_result', result: data.response });
        } else if (data.error) {
          dispatch({ type: 'error', error: data.error }); // busy, frequency_limit_reached
        } else {
          dispatch({ type: 'error', error: 'empty_response' });
        }
      })
      .catch((err) => {
        if (err.name === 'AbortError'){
          // console.log('aborted')
        } else {
          dispatch({ type: 'error', error: 'network' });
        }
        return;
      })
      .finally(() => {
        setIsLoading(false);
        dispatch({ type: 'emit_clear_fetching' })
      });

    return () => abort && abort();
  }, 100, [fetching]);


  const handleClick = () => {
    if (abortRef.current) abortRef.current();

    dispatch({ type: 'emit_fetching' });
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey && !fetching) {
      dispatch({ type: 'emit_fetching' });
    }
  }

  return (
    <div className="s-copywriter-prompt">
      <textarea className="form-control"
        maxLength={1024}
        placeholder={i18n.t('assistant.prompt')}
        value={prompt||""}
        onChange={handleChange}
        onKeyDown={handleKeyDown}

      />
      <div className="s-copywriter-prompt__action">
        <button className="btn btn-success btn-success_normal-padding" onClick={handleClick} disabled={fetching || !prompt || !prompt.length}>
          <i className="fi fi-sparkles" />
          {i18n.t('assistant.generate_new_text')}
          {isLoading && <div className="preloader"/>}
        </button>
        <div className="s-copywriter-prompt__action-desc">
          {fetching ? (
            i18n.t('assistant.fetching')
          ) : (
            i18n.t('assistant.can_take_while')
          )}
        </div>
      </div>
    </div>
  );
};

export default Prompt;
